/**
 * Library status enumeration
 * Represents the lifecycle states of a library
 */
export enum LibraryStatus {
  /** Library created and ready for processing */
  CREATED = 'CREATED',

  /** Library has been assigned to a plate/index - ready for run assignment */
  IN_LIBRARY = 'IN_LIBRARY',

  /** Library is assigned to an active run */
  IN_RUN = 'IN_RUN',

  /** Library processing completed successfully */
  COMPLETED = 'COMPLETED',

  /** Library is disabled and cannot be used */
  DISABLED = 'DISABLED'
}

/**
 * Type guard to check if a string is a valid LibraryStatus
 */
export function isValidLibraryStatus(
  value: string | null | undefined
): value is LibraryStatus {
  if (!value) {
    return false;
  }
  return Object.values(LibraryStatus).includes(value as LibraryStatus);
}
